export const queryKeys = {
  all: ["points"] as const,
  challenges: (userId?: string) => [...queryKeys.all, "challenges", userId] as const,
  wallet: (userId?: string) => [...queryKeys.all, "wallet", userId] as const,
};
